import { Component, Input, OnInit } from '@angular/core';
import * as d3 from 'd3';
import { ScatterPointDTO } from 'src/app/models/obs/scatterPointDTO';
import { Tier3 } from 'src/app/models/obs/tier3';
import { BridgeService } from 'src/app/services/util/bridge.service';


@Component({
  selector: 'app-scatter',
  templateUrl: './scatter.component.html',
  styleUrl: './scatter.component.scss'
})
export class ScatterComponent implements OnInit {

  @Input() private band: string;
  @Input() private scatterpoint: ScatterPointDTO[];
  @Input() private dx1: number;
  @Input() private dx2: number;
  @Input() private dy1: number;
  @Input() private dy2: number;

  idT3: number = 0;

  constructor(private bridgeServ: BridgeService) { }

  ngOnInit() {
    // Suscripción al Subject de comunicación del observable de IdT3
    this.bridgeServ.enviarIdObservable.subscribe(id => {
      this.idT3 = id;
    });
    if (this.band == 'risk') {
      this.drawRiskMap(this.scatterpoint);
    } else if (this.band == 'opp') {
      this.drawOppMap(this.scatterpoint);
    }
    this.cambioId(this.idT3);
  }

  drawRiskMap(data: any[]) {

    var self = this;
    const l = 10;
    // set the dimensions and margins of the graph
    var margin = { top: 10, right: 30, bottom: 30, left: 60 },
      width = 960 - margin.left - margin.right,
      height = 700 - margin.top - margin.bottom;

    // Remove previous svg
    d3.select("#svg-scatter").remove();

    // Append the svg object to the body of the page
    var svg = d3.select("#scatter")
      .append("svg")
      .attr("id", "svg-scatter")
      .attr("preserveAspectRatio", "xMinYMin meet")
      .attr("viewBox", "0 0 960 700")
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    var prom_x = 0;
    var prom_y = 0;

    //  Calculo de probabilidad e impacto medio
    data.forEach((d: any) => {
      prom_x += +d.probabilidad;
      prom_y += +d.impacto;
    });
    prom_x /= data.length;
    prom_y /= data.length;

    // Add X axis
    var x = d3.scaleLinear()
      .domain([this.dx1, this.dx2])
      .range([0, width]);
    svg.append("g")
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x));

    // Add Y axis
    var y = d3.scaleLinear()
      .domain([this.dy1, this.dy2])
      .range([height, 0]);
    svg.append("g")
      .call(d3.axisLeft(y));

    svg.append("line")
      .attr("class", "prom_x")
      .attr("x1", x(prom_x))
      .attr("y1", height)
      .attr("x2", x(prom_x))
      .attr("y2", 0)
      .style("stroke", "#B4484F")
      .style("stroke-dasharray", "5,5")
      .style("fill", "none");

    svg.append("line")
      .attr("class", "prom_y")
      .attr("x1", width)
      .attr("y1", y(prom_y))
      .attr("x2", 0)
      .attr("y2", y(prom_y))
      .style("stroke", "#B4484F")
      .style("stroke-dasharray", "5,5")
      .style("fill", "none");

    svg.append("text")
      .text("Probabilidad")
      .attr("fill", "black")
      .style("font-size", 16)
      .style("font-weight", "Bold")
      .attr("x", width / 2)
      .attr("y", height + 30)
      .style("text-anchor", "middle");

    svg.append("text")
      .text("Impacto")
      .attr("fill", "black")
      .style("font-size", 16)
      .style("font-weight", "Bold")
      .style("text-anchor", "middle")
      .attr("transform", "translate (" + -30 + ", " + height / 2 + ") rotate(270 )");

    // Add dots
    svg.append('g')
      .selectAll("dot")
      .data(data)
      .enter()
      .append("rect")
      .classed("rect", true)
      .attr("id", (d: any) => { return d.codigo; })
      .attr("x", (d: any) => {
        return +d.mp + x(d.probabilidad);
      })
      .attr("y", (d: any) => {
        return +d.mi + y(d.impacto) - l * Math.sqrt(2) / 2;
      })
      .attr("width", l)
      .attr("height", l)
      .attr('transform', (d: any) => {
        let mp = +d.mp + x(d.probabilidad);
        let mi = +d.mi + y(d.impacto) - l * Math.sqrt(2) / 2;
        return "rotate(45," + mp + "," + mi + ")"
      })
      .style("fill", (d: any) => { return d.color; })
      .on('click', click)
      .on("mouseenter", handleMouseOver)
      .on("mouseout", handleMouseOut);

    svg.append('g')
      .selectAll("text")
      .data(data)
      .enter()
      .append("text")
      .text((d: any) => { return d.etiqueta })
      .attr("class", "label")
      .attr("id", (d, i) => { return "text-" + d.codigo; })
      .attr("fill", "black")
      .style("font-size", 10)
      .attr("x", (d: any) => {
        let mp = +d.mp + x(d.probabilidad) + +d.mtx;
        return mp;
      })
      .attr("y", (d: any) => {
        let mi = +d.mi + y(d.impacto) + +d.mty;
        return mi;
      })
      .style("text-anchor", "middle")
      .attr("stroke", "white")
      .attr('paint-order', 'stroke')
      .attr('stroke-linejoin', 'round')
      .attr("stroke-width", 2);

    function click(e, d) {

      if (d.codigo) {
        window.open("../ficha/" + d.codigo);
        self.cambioId(self.idT3);
      }

      d3.selectAll(".label")
        .transition()
        .duration(250)
        .ease(d3.easeLinear)
        .style("fill", "black")
        .style("font-size", "10px")
        .style("font-weight", "normal");

      d3.selectAll("#text-" + d.codigo)
        .transition()
        .duration(250)
        .ease(d3.easeLinear)
        .style("fill", "#B4484F")
        .style("font-weight", "bold")
        .style('font-size', "12px");
    }

    function handleMouseOver(e, d) {
      // Detiene las transiciones actuales
      d3.selectAll(".rect").interrupt();
      // Inicia una nueva transición
      d3.selectAll(".rect")
        .transition()
        .duration(250)
        .ease(d3.easeLinear)
        .style("opacity", 0.4);
      // Inicia la transición en el elemento actual
      d3.select(this)
        .interrupt()
        .transition()
        .duration(250)
        .ease(d3.easeLinear)
        .style("opacity", 1.0)
        .attr("x", (d: any) => +d.mp + x(d.probabilidad))
        .attr("y", (d: any) => +d.mi + y(d.impacto) - l * 0.75 * Math.sqrt(2))
        .attr("width", l * 1.5)
        .attr("height", l * 1.5)
        .attr('transform', (d: any) => {
          let mp = +d.mp + x(d.probabilidad);
          let mi = +d.mi + y(d.impacto) - l * 0.75 * Math.sqrt(2);
          return `rotate(45,${mp},${mi})`;
        })
        .attr('cursor', 'pointer');
    }

    function handleMouseOut(e, d) {
      // Detiene las transiciones actuales
      d3.selectAll(".rect").interrupt();
      // Restaura las propiedades originales
      d3.selectAll(".rect")
        .transition()
        .duration(250)
        .ease(d3.easeLinear)
        .style("opacity", 1);
      // Restaura las propiedades originales en el elemento actual
      d3.select(this)
        .interrupt()
        .attr("x", (d: any) => +d.mp + x(d.probabilidad))
        .attr("y", (d: any) => +d.mi + y(d.impacto) - l * Math.sqrt(2) / 2)
        .attr("width", l)
        .attr("height", l)
        .attr('transform', (d: any) => {
          let mp = +d.mp + x(d.probabilidad);
          let mi = +d.mi + y(d.impacto) - l * Math.sqrt(2) / 2;
          return `rotate(45,${mp},${mi})`;
        })
        .attr('cursor', 'normal');
    }
  }

  drawOppMap(data: any[]) {
    var self = this;
    const l = 10;
    // set the dimensions and margins of the graph
    var margin = { top: 10, right: 30, bottom: 30, left: 60 },
      width = 960 - margin.left - margin.right,
      height = 700 - margin.top - margin.bottom;
    // Remove previous svg
    d3.select("#svg-scatter").remove();
    // Append the svg object to the body of the page
    var svg = d3.select("#scatter")
      .append("svg")
      .attr("id", "svg-scatter")
      .attr("preserveAspectRatio", "xMinYMin meet")
      .attr("viewBox", "0 0 960 700")
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    var prom_x = 0;
    var prom_y = 0;

    //  Calculo de probabilidad e impacto medio
    data.forEach((d: any) => {
      prom_x += +d.probabilidad;
      prom_y += +d.impacto;
    });
    prom_x /= data.length;
    prom_y /= data.length;

    // Add X axis
    var x = d3.scaleLinear()
      .domain([this.dx1, this.dx2])
      .range([0, width]);
    svg.append("g")
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x));

    // Add Y axis
    var y = d3.scaleLinear()
      .domain([this.dy1, this.dy2])
      .range([height, 0]);
    svg.append("g")
      .call(d3.axisLeft(y));

    svg.append("line")
      .attr("class", "prom_x")
      .attr("x1", x(prom_x))
      .attr("y1", height)
      .attr("x2", x(prom_x))
      .attr("y2", 0)
      .style("stroke", "#B4484F")
      .style("stroke-dasharray", "5,5")
      .style("fill", "none");

    svg.append("line")
      .attr("class", "prom_y")
      .attr("x1", width)
      .attr("y1", y(prom_y))
      .attr("x2", 0)
      .attr("y2", y(prom_y))
      .style("stroke", "#B4484F")
      .style("stroke-dasharray", "5,5")
      .style("fill", "none");

    svg.append("text")
      .text("Probabilidad")
      .attr("fill", "black")
      .style("font-size", 16)
      .style("font-weight", "Bold")
      .attr("x", width / 2)
      .attr("y", height + 30)
      .style("text-anchor", "middle");

    svg.append("text")
      .text("Impacto")
      .attr("fill", "black")
      .style("font-size", 16)
      .style("font-weight", "Bold")
      .style("text-anchor", "middle")
      .attr("transform", "translate (" + -30 + ", " + height / 2 + ") rotate(270 )");

    // Add dots
    svg.append('g')
      .selectAll("dot")
      .data(data)
      .enter()
      .append("circle")
      .classed("circle", true)
      .attr("id", (d: any) => { return d.codigo; })
      .attr("r", 7)
      .attr("cx", (d: any) => {
        return +d.mp + x(d.probabilidad);
      })
      .attr("cy", (d: any) => {
        return +d.mi + y(d.impacto);
      })
      .style("fill", (d: any) => { return d.color; })
      .on('click', click)
      .on("mouseenter", handleMouseOver)
      .on("mouseout", handleMouseOut);

    svg.append('g')
      .selectAll("text")
      .data(data)
      .enter()
      .append("text")
      .text((d: any) => { return d.etiqueta })
      .attr("class", "label")
      .attr("id", (d, i) => { return "text-" + d.codigo; })
      .attr("fill", "black")
      .style("font-size", 10)
      .attr("x", (d: any) => {
        let mp = +d.mp + x(d.probabilidad) + +d.mtx;
        return mp;
      })
      .attr("y", (d: any) => {
        let mi = +d.mi + y(d.impacto) + +d.mty;
        return mi;
      })
      .style("text-anchor", "middle")
      .attr("stroke", "white")
      .attr('paint-order', 'stroke')
      .attr('stroke-linejoin', 'round')
      .attr("stroke-width", 2);

    /*     var t = d3.transition()
          .duration(250)
          .ease(d3.easeLinear); */

    function click(e, d) {

      if (d.codigo) {
        window.open("../ficha/" + d.codigo);
        self.cambioId(self.idT3);
      }

      d3.selectAll(".label")
        .transition()
        .duration(250)
        .ease(d3.easeLinear)
        .style("fill", "black")
        .style("font-size", "10px")
        .style("font-weight", "normal");

      d3.selectAll("#text-" + d.codigo)
        .transition()
        .duration(250)
        .ease(d3.easeLinear)
        .style("fill", "#B4484F")
        .style("font-weight", "bold")
        .style('font-size', "12px");
    }

    function handleMouseOver(e, d) {
      // Detiene las transiciones actuales
      d3.selectAll(".circle").interrupt();
      // Inicia una nueva transición
      d3.selectAll(".circle")
        .transition()
        .duration(250)
        .ease(d3.easeLinear)
        .style("opacity", 0.4);
      // Inicia la transición en el elemento actual
      d3.select(this)
        .interrupt()
        .transition()
        .duration(250)
        .ease(d3.easeLinear)
        .style("opacity", 1.0)
        .attr("r", 9)
        .attr("cx", (d: any) => +d.mp + x(d.probabilidad))
        .attr("cy", (d: any) => +d.mi + y(d.impacto))
        .attr('cursor', 'pointer');
    }

    function handleMouseOut(e, d) {
      // Detiene las transiciones actuales
      d3.selectAll(".circle").interrupt();
      // Restaura las propiedades originales
      d3.selectAll(".circle")
        .transition()
        .duration(250)
        .ease(d3.easeLinear)
        .style("opacity", 1);
      // Restaura las propiedades originales en el elemento actual
      d3.select(this)
        .interrupt()
        .transition()
        .duration(250)
        .ease(d3.easeLinear)
        .style("opacity", 1.0)
        .attr("r", 7)
        .attr("cx", (d: any) => +d.mp + x(d.probabilidad))
        .attr("cy", (d: any) => +d.mi + y(d.impacto))
        .attr('cursor', 'pointer');
    }
  }
  // Función de envío de mensaje
  cambioId(id: number) {
    this.bridgeServ.enviarIdT3(id);
  }
}

